import { css, Styles, ThemeColorCallback, withStyles } from '@recruit-robin/robin-theme/web-styles';

import type { ToastVariant } from '../../lib';

type VariantColorKey = 'backgroundColor' | 'textColor';

const getVariantColors = (
  variant: ToastVariant,
): Record<VariantColorKey, Exclude<ThemeColorCallback, 'currentColor'>> => {
  switch (variant) {
    case 'success':
      return {
        backgroundColor: (c) => c.secondary.emerald[20],
        textColor: (c) => c.secondary.emerald[60],
      };
    case 'error':
      return {
        backgroundColor: (c) => c.tertiary.red[20],
        textColor: (c) => c.tertiary.red[60],
      };
    case 'info':
      return {
        backgroundColor: (c) => c.secondary.sky[20],
        textColor: (c) => c.secondary.sky[60],
      };
    case 'warning':
      return {
        backgroundColor: (c) => c.tertiary.lime[10],
        textColor: (c) => c.tertiary.lime[50],
      };
  }
};

export const toastVariants = {
  initial: {
    opacity: 0,
    x: 100,
    scale: 0.95,
  },
  animate: {
    opacity: 1,
    x: 0,
    scale: 1,
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.2,
    },
  },
};

const styles = {
  root: ({ theme, props }) => {
    const colors = getVariantColors(props.variant);

    return css`
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 12px 16px;
      min-width: 210px;
      max-width: 340px;

      border-radius: 8px;
      border: 1px solid ${theme.colors.neutral.variant[20]};
      background-color: white;
      color: ${colors.textColor(theme.colors)};
    `;
  },
  icon: ({ theme, props }) => {
    const colors = getVariantColors(props.variant);

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      padding: 4px;
      border-radius: 50%;
      color: ${colors.textColor(theme.colors)};
      background-color: ${colors.backgroundColor(theme.colors)};
    `;
  },
  message: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,
  closeButton: css`
    margin-left: auto;
  `,
} satisfies Styles<{ variant: ToastVariant }>;

export const useStyles = withStyles(styles);
